export default __webpack_public_path__ + "static/media/loader.4a320037.gif";